import Footer from 'components/Footer/Footer'
import PerfectScrollbar from 'perfect-scrollbar'
import React, { useEffect, useRef } from 'react'
import LayoutRoutes from 'routes/LayoutRoutes'

let ps

const Auth = () => {
  const fullPages = useRef(null)

  useEffect(() => {
    if (navigator.platform.indexOf('Win') > -1) {
      ps = new PerfectScrollbar(fullPages.current)
    }
    return () => {
      if (navigator.platform.indexOf('Win') > -1 && ps) {
        ps.destroy()
      }
    }
  }, [fullPages])

  return (
    <>
      <div className="wrapper wrapper-full-page" ref={fullPages}>
        <div className="full-page section-image">
          <LayoutRoutes />
          <Footer fluid />
        </div>
      </div>
    </>
  )
}

export default Auth
